<div class="fetch-more-button-container" prlwResponsive>
  <button
    class="fetch-more-button"
    [disabled]="buttonLoading"
    (click)="eventFetchMore.emit()"
    prlwResponsive
  >
    <div class="dot-container" *ngIf="buttonLoading; else buttonLabel">
      <span class="dot dot--1"></span>
      <span class="dot dot--2"></span>
      <span class="dot dot--3"></span>
    </div>
    <ng-template #buttonLabel>
      {{ fetchMoreLabel }}
    </ng-template>
  </button>
</div>
